module.exports = __webpack_public_path__ + "img/contact_banner.a6e4ce65.jpg";